// WIP
// import Goals from 'components/MeshList/goals/Goals';
import React, { useEffect } from 'react';

import { combineReducers } from '@reduxjs/toolkit';
import { fetchTasksAction, removeTaskAction, updateTaskAction } from 'actions/task';
import tabReducer, { tabReducerInitialState } from 'components/MeshList/tabReducer';
import useReducerWithThunk from 'components/hooks/useReducerWithThunk';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import apiPaginationMetaReducer, { apiPaginationMetaInitialState } from 'reducers/apiPaginationMeta';
import apiStatusReducer, { apiStatusInitialState } from 'reducers/apiStatus';
import tasksReducer from 'reducers/task';
import { useSelectedView } from 'reducers/viewsSlice';
import {
  completedOnFilterReducer,
  buildCompletedOnFilterInitialState,
} from 'screens/Team/TeamPageFilters/CompletedOnFilter';
import { employeeFilterReducer } from 'screens/Team/TeamPageFilters/EmployeeFilter';
import { selectTeamPageGlobalFilters } from 'selectors/globalFilters';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import styled from 'styled-components';
import { HideScrollbarCSS } from 'styles/common';

// import useForceUpdate from 'components/hooks/useForceUpdate';
import { TASK_TYPES_2, TEAM_TASKS_VIEW_TYPES } from 'constants/ProjectConstants';
import { generateKey } from 'constants/helper';

import { getStartEndTimeFromDurationKey } from 'services/helpers/task';
import { showTaskDetails } from 'services/taskDetails';

import GoalListItem from './components/GoalListItem';

const { startTS, endTS } = getStartEndTimeFromDurationKey('LASTYEAR');

const filterInitialState = {
  completedOnFilter: buildCompletedOnFilterInitialState({
    from: new Date(startTS),
    to: new Date(endTS),
  }),
  employeeFilter: {},
};

const tabStateWithGoalSelected = { ...tabReducerInitialState, selected: -1 };

const meshListReducerInitialState = {
  tabs: tabStateWithGoalSelected,
  filters: filterInitialState,
  tasks: [],
  apiStatus: apiStatusInitialState,
  apiPaginationMeta: apiPaginationMetaInitialState,
};

function buildMeshInitialState(employeeId) {
  const apiPaginationMeta = {
    ...apiPaginationMetaInitialState,
    paginationKey: generateKey(8),
    limit: 100,
  };
  const initialState = { ...meshListReducerInitialState, apiPaginationMeta };
  return addCurrentEmployeeFilter(initialState, employeeId);
}

function addCurrentEmployeeFilter(state, employeeId) {
  const newState = { ...state };
  const employeeFilter = { [employeeId]: true };
  newState.filters = { ...state.filters, employeeFilter };
  return newState;
}

const filterReducer = combineReducers({
  completedOnFilter: completedOnFilterReducer,
  employeeFilter: employeeFilterReducer,
});

const meshListReducer = combineReducers({
  tabs: tabReducer,
  filters: filterReducer,
  tasks: tasksReducer,
  apiPaginationMeta: apiPaginationMetaReducer,
  apiStatus: apiStatusReducer,
});

const GoalList = ({ objective, forceUpdateValue }) => {
  const loggedInEmployee = useSelector(selectLoggedInEmployeeData, shallowEqual);
  const selectedCohort = useSelectedView();

  const [state, dispatch] = useReducerWithThunk(meshListReducer, buildMeshInitialState(loggedInEmployee.id));

  const globalFilters = useSelector(selectTeamPageGlobalFilters, shallowEqual);

  const { tasks = [] } = state;

  useEffect(() => {
    // exclude the one selected in top team filters, if any
    const globalFiltersWithoutTopLevelObjectiveFilter = globalFilters.filters.filter(
      (item) => item.type !== 'TIMEBOUND_OBJECTIVE'
    );
    dispatch(
      fetchTasksAction({
        type: TASK_TYPES_2.goal,
        globalFilters: {
          ...globalFilters,
          filters: [
            ...globalFiltersWithoutTopLevelObjectiveFilter,
            // add the one from objective node
            {
              type: 'TIMEBOUND_OBJECTIVE',
              value: objective.objectiveTimeBoundId,
              operator: 'IN',
            },
          ],
        },
        timeBoundPeriod: objective.timeBoundDetails,
        includeEmployeeFilters: true,
        resourceType: TEAM_TASKS_VIEW_TYPES.goalTree,
        selectedCohort,
      })
    );
  }, [forceUpdateValue]);

  return <>{tasks.length === 0 ? null : <Goals goals={tasks} listDispatch={dispatch} />}</>;
};

export default GoalList;

// ----------------------------------------------------------
const TasksGoalsContainer = styled.div`
  background-color: #ffffff;
  width: 100%;
  overflow-y: scroll;
  height: 100%;
  ${HideScrollbarCSS};
`;

function Goals({ goals, pageType, employee, listDispatch }) {
  const reduxDispatch = useDispatch();

  const showDetails = (e, taskId, type) => {
    if (e) e.stopPropagation();
    reduxDispatch(
      showTaskDetails({
        taskIds: [taskId],
        onDelete: () => {
          listDispatch(removeTaskAction(taskId));
        },
        onUpdate: (task) => {
          if (task) listDispatch(updateTaskAction(task));
        },
        employee,
        type,
      })
    );
  };

  return (
    <TasksGoalsContainer>
      {goals.map((goal) => (
        <GoalListItem
          key={`goal${goal.id}`}
          goal={goal}
          onClickHandler={(e) => showDetails(e, goal.id, goal.type)}
          employee
        />
      ))}
    </TasksGoalsContainer>
  );
}
